import { render, staticRenderFns } from "./utils-talks-page.vue?vue&type=template&id=f51c8000&scoped=true"
import script from "./utils-talks-page.vue?vue&type=script&lang=js"
export * from "./utils-talks-page.vue?vue&type=script&lang=js"
import style0 from "./utils-talks-page.vue?vue&type=style&index=0&id=f51c8000&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51c8000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f51c8000')) {
      api.createRecord('f51c8000', component.options)
    } else {
      api.reload('f51c8000', component.options)
    }
    module.hot.accept("./utils-talks-page.vue?vue&type=template&id=f51c8000&scoped=true", function () {
      api.rerender('f51c8000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/muiutils/views/utils-talks-page.vue"
export default component.exports